// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__nSH30","checkBox":"style_checkBox__ZaEIj","text":"style_text__y+4Rl"};